import { FileTypeEnum } from "../graphql/graphql";
// A list of file types derived from the enum (used by FileUploadPreviewCard)
export const FILE_TYPE_OPTIONS = [
    { value: FileTypeEnum.CsvUpload, label: "CSV" },
    { value: FileTypeEnum.PdfUpload, label: "PDF" },
    { value: FileTypeEnum.DocumentUpload, label: "DOCUMENT" },
    { value: FileTypeEnum.ImageUpload, label: "IMAGE" },
    { value: FileTypeEnum.VideoUpload, label: "VIDEO" },
    { value: FileTypeEnum.ZipUpload, label: "ZIP" },
    { value: FileTypeEnum.OtherUpload, label: "OTHER" }
];
